import { render } from "./AdminGeneral.vue?vue&type=template&id=7d2f6ff0&scoped=true"
import script from "./AdminGeneral.vue?vue&type=script&lang=js"
export * from "./AdminGeneral.vue?vue&type=script&lang=js"

import "./AdminGeneral.vue?vue&type=style&index=0&id=7d2f6ff0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2f6ff0"]])

export default __exports__